export const getAuthIsPosting = state => state.authReducer.isPosting;
export const getAuthPostSuccess = state => state.authReducer.postSuccess;
export const getAuthError = state => state.authReducer.error;
export const getAuthLoginStep = state => state.authReducer.loginStep;
export const getPostTokenSuccess = state => state.authReducer.postSuccessToken;
